module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Voip")]), (_vm.current_user.isAdmin() || _vm.current_user.isManager()) ? _c('div', [_c('hr'), _vm._m(0), _c('br'), _vm._m(1), _c('br'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('caller_id')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (_vm.dynamicMask),
      expression: "dynamicMask"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.caller_id),
      expression: "caller_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "caller_id",
      "name": "caller_id",
      "type": "text",
      "placeholder": "(00) 00000-0000"
    },
    domProps: {
      "value": (_vm.caller_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.caller_id = $event.target.value
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('caller_id')),
      expression: "errors.has('caller_id')"
    }],
    key: "caller_id",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('caller_id')))])])], 1)]), _c('div', {
    staticClass: "col-md-8"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.openModalConfirmation
    }
  }, [_vm._v("Salvar")])])]), _c('br')]) : _vm._e(), _c('strong', [_vm._v("DASHBOARD")]), _c('hr'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "company-name"
  }, [_vm._v(_vm._s(_vm.current_company.name))])]), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "progression-bar"
  }, [_c('div', {
    staticClass: "bar-color"
  }), _c('div', {
    staticClass: "bar-background",
    style: ({
      width: _vm.calc_bar_percentage + '%'
    })
  })]), _c('div', {
    staticClass: "plan-status text-center"
  }, [_vm._v("Plano contratado: " + _vm._s(_vm.numeric_status))]), _c('div', {
    staticClass: "plan-status text-center"
  }, [_vm._v("Minutos adicionais restantes: "), _c('span', {
    staticClass: "additional-time-info"
  }, [_vm._v(_vm._s(_vm.additional_time))])])])]), _c('hr'), _c('date-range-picker', {
    ref: "date_range_picker",
    attrs: {
      "id": "date-picker-voip",
      "this_month": true
    },
    on: {
      "date-changed": _vm.dateChanged
    }
  }), _c('div', {
    attrs: {
      "id": "voip-cards"
    }
  }, _vm._l((_vm.voipCards), function(voipCard) {
    return (voipCard.title) ? _c('voip-card', {
      attrs: {
        "number": voipCard.number,
        "cssClass": voipCard.cssClass,
        "title": voipCard.title,
        "type": voipCard.type
      }
    }) : _vm._e()
  }), 1), _c('hr'), _c('div', {
    attrs: {
      "id": "report-list"
    }
  }, [_c('report-list', {
    attrs: {
      "voipCalls": _vm.voipCalls
    },
    on: {
      "next-page": _vm.loadVoipCalls
    }
  }), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.next_page),
      expression: "!next_page"
    }],
    staticClass: "light-gray-text light-text"
  }, [_vm._v("Sem mais resultados")])])], 1), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": _vm.loading
    }
  })], 1), _c('confirm', {
    attrs: {
      "id": "confirm-voip-caller_id",
      "title": "O número de ligação sera redefinido",
      "message": "Ao definir um número de VoiP para a empresa, os números definidos para todos os usuários da empresa serão alterados. Deseja prosseguir?",
      "reject_text": "Cancelar",
      "confirm_text": "Confirmar"
    },
    on: {
      "confirm-modal-confirm": _vm.save
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('strong', [_vm._v("CONFIGURAÇÕES")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_vm._v("Qual número de telefone deve aparecer para as pessoas que receberem ligações dos meus vendedores?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b3dadb6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/voip.vue
// module id = 1013
// module chunks = 1